import { linesConfigGlobal, setBetValueGlobal } from "../config/GlobalVariableConfig";

// import { spinResponseDataGlobal } from "../config/GlobalVariableConfig";

import { valMap } from "../config/getSymbol";
import { REEL_NUMBERS, SYMBOLS_PER_REEL } from "../config/reelConfig";
import { GameConstants } from "../gameClientEvents/GameConstants";
const numberUnit = 0.01; // in cents


export interface WinObject { // the object -how we want to use in our program 
    lineId: number | null;
    count: number;
    symbolId: number;
    winAmount: number;
    winSymbolPosistions: number[][] | null;
    winMultiplier: number;
    bonusWon: string;
}
export interface ISpinLeftObject { // the object -how we want to use in our program 
    isReduceSpins: boolean;
    value: number;
}

export interface INudgeInfo {
    dir: string;
    reelNum: number;
    posNum: number;
    count: number
}

export interface IFeatureData {
    reelHeightPerReel: number[];
    coinInfo?: {
        initialCoinValues: number[][];
        coinValues: number[][];
        multiplierValues: number[][];
        spinLeft: ISpinLeftObject | null;
    },
    nudgeInfo?: INudgeInfo[] | null;
    isHoldAndSpin: boolean;
}

interface spinLeftObject { // the object -how we want to use in our program 
    isReduceSpins: boolean;
    value: number;
}

export interface RespinObject { // the object -how we want to use in our program 

    type: string;
    freeGameTrigger: number;
    reelSymbols: number[][];
    winLines: WinObject[] | null; // Making winLines optional because might be no win
    winScatters: WinObject[] | null;
    winAmount: number; // win of that particular cascade respin 
    multiplier: number; // accumulated multiplier applicable on  that particular respin 
    accumulatedsWinAmount: number; // win of that particular respin total
    cascadePositions: number[][];

    mice: boolean[];
    catMultiplier: number[][];
    featureData: IFeatureData | null;
    isMaxwinJackpotWon: boolean;
}

export interface SpinDataObject { // the object -how we want to use in our program 

    dataFeatched: boolean;
    isBuyFeatureActive: boolean;
    betAmount: number;

    // state value - kind of header
    freeGameTrigger: number; // number of fs won in base game
    freeGameReTrigger: number;  // number of fs won in free game
    totalFreeGame: number; // total number of fs - to show in counter 
    remainingFreeGame: number; // remaining number of fs - to show in counter 
    totalAccumulatedWin: number; // used specially in free games
    totalWin: number;  // win of current spin including all respins
    balance: number;
    isWinHigherBet: boolean;
    isMaxwinJackpotWon: boolean;
    respins: RespinObject[];

};



export const spinData: SpinDataObject = { // use in other class

    dataFeatched: false,
    isBuyFeatureActive: false,
    betAmount: 0,
    freeGameTrigger: 0,
    freeGameReTrigger: 0,
    totalFreeGame: 0,
    remainingFreeGame: 0,
    totalAccumulatedWin: 0,
    totalWin: 0,
    balance: 0,
    isWinHigherBet: false,
    isMaxwinJackpotWon: false,
    respins: []
};

export function resetSpinData(): void {
    spinData.dataFeatched = false;

    spinData.isBuyFeatureActive = false;

    spinData.freeGameTrigger = 0;
    spinData.freeGameReTrigger = 0;
    spinData.totalFreeGame = 0;
    spinData.remainingFreeGame = 0;
    spinData.totalAccumulatedWin = 0;
    spinData.totalWin = 0;
    spinData.balance = 0;
    spinData.isWinHigherBet = false;
    spinData.isMaxwinJackpotWon = false;

    spinData.respins = [];
}


// export async function spinResponse(): Promise<void> {

//     console.log('insidespinResponse');

//     parserSpinResponse(spinResponseDataGlobal);

// }



export function parserSpinResponse(data: any): void {
    console.log("inside parserSpinResponse", data);



    // Initialize the SpinDataObject
    spinData.dataFeatched = true;

    spinData.isBuyFeatureActive = !!data?.activeFeatureBuyData;

    spinData.betAmount = Number(data.betAmountString) / 100;
    setBetValueGlobal(spinData.betAmount);

    if (Number(data.latestWinString) > Number(data.betAmountString)) {
        spinData.isWinHigherBet = true;
    } else {
        spinData.isWinHigherBet = false;
    }


    //  const isMaxWinReached = data.events.some((a: any) => a.etn === "max_win_reached");
    const REEL_NUMBERS = 5;
    const MAX_ROWS = 8;
    let persistentMask = Array.from({ length: REEL_NUMBERS }, () =>
        Array(MAX_ROWS).fill(false)
    );

    data.events.forEach((event: any) => {
        let featureData: IFeatureData = { reelHeightPerReel: [3, 4, 4, 4, 3], coinInfo: { initialCoinValues: [], coinValues: [], multiplierValues: [], spinLeft: null }, nudgeInfo: [], isHoldAndSpin: false };

        // Each spin will be treated as a respin
        let reelSymbols: number[][] = (event.c && event.c.grid) ? decodeGrid(event.c.grid) : [];
        let height = (event.c && event.c?.reelSet);

        const digit = (height && height !== "default")
            ? parseInt(height.match(/\d+$/)?.[0]) || 4
            : 4;

        featureData.reelHeightPerReel = [3, digit, digit, digit, 3];

        let stepCoinValues = Array.from({ length: REEL_NUMBERS }, () => Array(MAX_ROWS).fill(0));
        let initialCoinValues: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
            Array(MAX_ROWS).fill(0)
        );
        // let hasNewCoin = false;

        reelSymbols = reelSymbols.map((row, rowIndex) => {

            let newRow = row.map(symbol => symbol === -2 ? 31 : symbol);
            if (rowIndex === 4) {
                newRow = newRow.map(symbol => symbol === 0 ? 30 : symbol);
            }
            while (newRow.length < 8) {
                newRow.unshift(31);
            }
            return newRow;
        });


        console.log(reelSymbols);

        let respinWinAmount = Number((event.wa * numberUnit).toFixed(2)); // Total win of that particular respin

        let accumWinAmount = Number((event.awa * numberUnit).toFixed(2)); // Total win of that particular respin

        let totalMultiplier = 1;

        const type = (event.etn === "hold_and_win") ? "reveal" : (event.etn === "fs_hold_and_win" ? "fs_reveal" : event.etn); // Treat the initial hold_and_win event as a "reveal" type respin
        // const type = event.etn;
        let spinLeft = null;
        let isMaxwinJackpotWonInRespin = false;
        // // Check for feature spin (e.g., free game trigger)
        let freeGameTrigger = 0;
        if (event.etn === "feature_enter") {
            freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.totalFreeGame = Number(event.c.bonusFeatureCount) || 0;
        }

        const winLines: WinObject[] = [];
        const winScatters: WinObject[] = [];
        const cascadePositions: number[][] = [];

        let mice: boolean[] = [];

        const catMultiplier: number[][] = SYMBOLS_PER_REEL.map((rowCount) =>
            Array(rowCount).fill(0)
        );

        event.c && event.c.actions?.forEach((action: any) => {
            initialCoinValues = getCoinData(reelSymbols);
            // stepCoinValues = getCoinData(reelSymbols);

            if (action.at === "mice") {

                mice = action.data.v.map((value: boolean) => value);

            }
            else if (action.at === "cat") {

                const [reelNum, posNum] = [action.data.p % REEL_NUMBERS, Math.floor(action.data.p / REEL_NUMBERS)];
                const multiplier = Number(action.data.m);

                catMultiplier[reelNum][posNum] = multiplier;

            } else if (action.at === "drillNudge") {
                const reelNum = Number(action.data.c);
                const dir = action.data.d; // "up" or "down"
                let posNum;
                if (reelSymbols[reelNum]) {
                    let symbolCount = reelSymbols[reelNum].filter(symbol => symbol === GameConstants.SILVER_WILD_SYMOL_ID || symbol === GameConstants.GOLDEN_WILD_SYMOL_ID).length;
                    if (dir === "down") {
                        posNum = 5;
                    } if (dir === "up") {
                        posNum = 7;
                    }
                    console.log("drillNudge action", reelNum, dir, symbolCount, posNum);
                    featureData.nudgeInfo.push({
                        reelNum: reelNum,
                        dir: dir,
                        posNum: posNum,
                        count: symbolCount
                    });
                }
            } else if (action.at === "holdAndWin") {
                featureData.isHoldAndSpin = true;
            } else if (action.at === "stick") {
                let currentMask = action.data.mask;
                for (let i = 0; i < currentMask.length; i++) {
                    const rowsInString = event.c ? Math.floor(event.c?.grid?.length / REEL_NUMBERS) : 0;
                    const rowOffset = MAX_ROWS - rowsInString;
                    if (currentMask[i] === '1') {
                        const reelId = i % REEL_NUMBERS;
                        const posNum = Math.floor(i / REEL_NUMBERS) + rowOffset;
                        const symbolId = reelSymbols[reelId][posNum];
                        const isCoin = symbolId >= GameConstants.GOLD_COIN_START_SYMBOL_ID && symbolId <= GameConstants.GRAND_SYMBOL_ID;
                        if (isCoin && !persistentMask[reelId][posNum]) {
                            const val = valMap[symbolId] || 0;
                            stepCoinValues[reelId][posNum] = val;
                            //  if (val > 0) hasNewCoin = true;
                        }
                        persistentMask[reelId][posNum] = true;
                    }
                }
            }
            if (action.at === "gridwin") { // Handling win lines or win scatters
                const symbolId = Number(action.data.symbol);

                const winAmount = Number(action.data.winAmount * numberUnit);
                const winSymbolPositions = action.data.mask ? getReelPositions2(action.data.mask) : [];
                const winMultiplier = action.data.winMultipliers ? Number(action.data.winMultipliers[0]) : 1;
                const bonusWon = action.data.bonusWon || ""; // Assuming you want to track bonus wins
                const count = Number(action.data.count)

                const lineId = getLineId(winSymbolPositions, count);


                const winObject: WinObject = {
                    lineId,
                    count,
                    symbolId,
                    winAmount,
                    winSymbolPosistions: winSymbolPositions.length > 0 ? winSymbolPositions : null,
                    winMultiplier,
                    bonusWon
                };

                if (symbolId === 12) { // Assuming symbol 15 is a scatter
                    winScatters.push(winObject);
                } else {
                    winLines.push(winObject);
                }
            }
            if (action.at === "cashWin") {
                 const symbolId = Number(action.data.symbol || GameConstants.GOLD_COIN_START_SYMBOL_ID);

                const winAmount = Number(action.data.w * numberUnit);
                const winSymbolPositions = action.data.h ? getReelPositions2(action.data.h) : [];
                const count = Number(winSymbolPositions.length);
                const winMultiplier = action.data.winMultipliers ? Number(action.data.winMultipliers[0]) : 1;
                const bonusWon = action.data.bonusWon || ""; // Assuming you want to track bonus wins
                const lineId = getLineId(winSymbolPositions, count);

                const winObject: WinObject = {
                    lineId,
                    count,
                    symbolId,
                    winAmount,
                    winSymbolPosistions: winSymbolPositions.length > 0 ? winSymbolPositions : null,
                    winMultiplier,
                    bonusWon
                };

                winLines.push(winObject);
            }
            else if (action.at === "remove") { // Handling wild multiplier

                action.data.mask ? getReelPositions(action.data.mask) : [];
                const mask = action.data.mask; // Mask as string of 0s and 1s

                if (mask.length > 0) {
                    for (let i = 0; i < mask.length; i++) {
                        if (mask[i] === '1') { // Only process positions marked as '1'
                            const position: [number, number] = [
                                i % REEL_NUMBERS,               // Reel Number
                                Math.floor(i / REEL_NUMBERS)    // Position
                            ];
                            cascadePositions.push(position);
                        }
                    }
                }
            } else if (action.at === "reduceSpins") {
                const spinLeftVal: spinLeftObject = {
                    isReduceSpins: true,
                    value: Number(action.data.v)
                };
                spinLeft = spinLeftVal;
            }
            else if (action.at === "refillSpins") {
                const spinLeftVal: spinLeftObject = {
                    isReduceSpins: false,
                    value: Number(action.data.v)
                };
                spinLeft = spinLeftVal;
            } else if (action.at === "maxWinJackpot") {
                spinData.isMaxwinJackpotWon = true;
                isMaxwinJackpotWonInRespin = true;
            }

        });

        featureData.coinInfo.coinValues = stepCoinValues;
        featureData.coinInfo.initialCoinValues = initialCoinValues;
        featureData.coinInfo.spinLeft = spinLeft;

        // Create the RespinObject and push it to spinData.respins
        const respin: RespinObject = {
            type: type,
            freeGameTrigger: freeGameTrigger,
            reelSymbols: reelSymbols,
            winLines: winLines.length > 0 ? winLines : null,
            winScatters: winScatters.length > 0 ? winScatters : null,
            winAmount: respinWinAmount,
            cascadePositions: cascadePositions,
            multiplier: totalMultiplier,
            accumulatedsWinAmount: accumWinAmount,
            mice: mice,
            catMultiplier: catMultiplier,
            featureData: featureData,
            isMaxwinJackpotWon: isMaxwinJackpotWonInRespin
        };

        spinData.respins.push(respin);


    });

    console.log("Parsed spin data:", spinData);

}


function getCoinData(reelSymbols: number[][]) {
    let initialCoinValues: number[][] = SYMBOLS_PER_REEL.map((rowCount) => Array(rowCount).fill(0));
    let coinValues: number[][] = SYMBOLS_PER_REEL.map((rowCount) => Array(rowCount).fill(0));

    for (let col = 0; col < reelSymbols.length; col++) {
        for (let row = 0; row < reelSymbols[col].length; row++) {
            const symbolId = reelSymbols[col][row];
            const multiplierVal = valMap[symbolId] || 0;
            initialCoinValues[col][row] = multiplierVal;
            coinValues[col][row] = multiplierVal;
        }
    }
    return coinValues;
}

function decodeGrid(grid: string): number[][] {
    const offset = 40; // ASCII offset for encoding

    // Extract width and height from the first two characters
    const width = grid.charCodeAt(0) - offset;
    const height = grid.charCodeAt(1) - offset;

    // Initialize the 2D array for storing the grid
    const gridArray = [];

    // Populate the 2D array with decoded values
    let index = 2; // Start from the third character
    for (let row = 0; row < height; row++) {
        const currentRow = [];
        for (let col = 0; col < width; col++) {
            // Convert each character to its decimal value using the offset
            const cellValue = grid.charCodeAt(index) - offset;
            currentRow.push(cellValue);
            index++;
        }
        gridArray.push(currentRow);
    }


    // console.log(gridArray);

    // Transpose the 2D array (swap rows with columns)
    const transposedArray = transposeMatrix(gridArray);

    // function to transpose a matrix (2D array)
    function transposeMatrix(matrix: number[][]) {
        return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    }

    return transposedArray;

}

function getReelPositions(binaryString: string): [number, number][] {

    // const rows = Math.ceil(binaryString.length / REEL_NUMBERS);
    const result: [number, number][] = [];

    // Loop through the binary string and fill the 2D array conceptually
    for (let i = 0; i < binaryString.length; i++) {
        const reelId = i % REEL_NUMBERS;          // Column number (reelId)
        const positionNum = Math.floor(i / REEL_NUMBERS); // Row number (position)

        if (binaryString[i] === '1') {
            result.push([reelId, positionNum]);
        }
    }

    return result;
}

//@ts-ignore
function getReelPositions2(binaryString: string): [number, number][] {
    const REEL_NUMBERS = 5;
    const MAX_ROWS = 8;

    const rowsInString = Math.floor(binaryString.length / REEL_NUMBERS);

    const rowOffset = MAX_ROWS - rowsInString;

    const result: [number, number][] = [];

    for (let i = 0; i < binaryString.length; i++) {
        if (binaryString[i] === '1') {
            const reelId = i % REEL_NUMBERS;
            const positionNum = Math.floor(i / REEL_NUMBERS) + rowOffset;

            result.push([reelId, positionNum]);
        }
    }

    return result;
}



function getLineId(winSymbolPositions: number[][], count: number): number | null {
    // Create an array to represent the line structure from winSymbolPositions
    const positionsByReel: number[] = [];

    for (let i = 0; i < winSymbolPositions.length; i++) {
        const [reel, pos] = winSymbolPositions[i];
        positionsByReel[reel] = pos;
    }

    // Compare with each line in linesConfigGlobal
    for (let lineIndex = 0; lineIndex < linesConfigGlobal.length; lineIndex++) {
        const lineConfig = linesConfigGlobal[lineIndex];


        let match = true;
        for (let reel = 0; reel < count; reel++) {
            if (positionsByReel[reel] !== lineConfig[reel]) {
                match = false;
                break;
            }
        }

        if (match) return lineIndex;
    }

    return null; // No match found
}



